import { createStore } from 'zustand';
import { SigninNavigationStore, SigninNavigationStoreFunction } from './SigninNavigationContext';
import { LoginFormPanel } from '@components/forms/login/LoginForm/LoginForm';
import { AuthType } from '@ul/api';

export const createSigninNavigationStore = (isBvariant: boolean = false) => {
    return createStore<SigninNavigationStore & SigninNavigationStoreFunction>()(set => ({
        useUnifiedAuthPage: isBvariant,
        initialLegacyTab: undefined,
        initialUsernameValue: '',
        setInitialUsernameValue: (username: string) => set(() => ({ initialUsernameValue: username })),
        setUseUnifiedAuthPage: (useUnifiedAuthPage: boolean) => set(() => ({ useUnifiedAuthPage })),
        setInitialLegacyTab: (initialLegacyTab: AuthType) => set(() => ({ initialLegacyTab })),
    }));
};
